/**
 * @Author: luoob
 * @Date: 2021-03-23 14:52:00
 * @Last Modified by: luoob
 * @Last Modified time: 2021-03-23 14:52:00
 * @Introduction: 工具模块路由
 */

import { RouteConfig } from 'vue-router'
/* Layout */
import Layout from '@/layout/index.vue'

const PhotoUpload = () => import('@/views/upload/photo.vue')
const ExportKeywords = () => import('@/views/otherTools/exportKeywords.vue')
const utilsRoute: RouteConfig = {
    path: '/utils',
    component: Layout,
    meta: {
        icon: 'icon-gongju',
        title: '其他工具',
        alwaysShow: true                // will always show the root menu
    },
    children: [
        {
            path: 'photo',
            component: PhotoUpload,
            name: 'PhotoUpload',
            meta: {
                title: '上传图片'
            }
        },
        {
            path: 'exportKeywords',
            component: ExportKeywords,
            name: 'ExportKeywords',
            meta: {
                title: '导出关键词'
            }
        }
    ]
}

export default utilsRoute
